export const DEFAULT_REDIRECT_URL = '/dashboard';
export const HOMEPAGE = '/';